module.exports = __webpack_public_path__ + "img/complimentary-card.a97b9e94.jpg";